export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      portal: 'Mi Portal de Taxes',
      switchLang: 'English'
    },
    hero: {
      title: 'Tu Camino Seguro en Inmigración y Finanzas',
      subtitle: 'Expertos dedicados a guiarte en tus trámites migratorios y preparación de impuestos con honestidad y precisión.',
      cta1: 'Consulta Gratuita',
      cta2: 'Reportar Taxes Ahora',
      portalCta: 'Mi Portal de Taxes'
    },
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Soluciones integrales para tu tranquilidad legal y financiera en Estados Unidos.',
      immigration: {
        title: 'Servicios de Inmigración',
        desc: 'Te acompañamos en cada paso de tu proceso migratorio con asesoría experta.',
        items: ['Peticiones Familiares', 'Ciudadanía y Naturalización', 'Permisos de Trabajo', 'Renovación de Residencia (Green Card)', 'Asilo y DACA']
      },
      taxes: {
        title: 'Preparación de Taxes',
        desc: 'Maximizamos tu reembolso y aseguramos el cumplimiento con el IRS.',
        items: ['Taxes Personales y de Negocios', 'Aplicación y Renovación de ITIN', 'Enmiendas de Años Anteriores', 'Asesoría Financiera', 'Contabilidad Básica'],
        portalBtn: 'Ir al Portal de Taxes',
        scanText: 'Escanea para Reportar'
      }
    },
    about: {
      title: 'Por Qué Elegirnos',
      desc: 'Con años de experiencia sirviendo a la comunidad hispana, entendemos tus necesidades y preocupaciones. Nuestro compromiso es brindarte un servicio transparente, rápido y efectivo.',
      stats: [
        { label: 'Años de Experiencia', value: '10+' },
        { label: 'Casos Exitosos', value: '5k+' },
        { label: 'Clientes Satisfechos', value: '100%' }
      ]
    },
    contact: {
      title: 'Contáctanos Hoy',
      subtitle: 'Estamos aquí para ayudarte a navegar tus trámites con confianza.',
      form: {
        name: 'Nombre Completo',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        service: 'Servicio de Interés',
        message: 'Mensaje',
        submit: 'Enviar Mensaje'
      },
      info: {
        address: 'Sirviendo a la Comunidad del Condado de Kern\nCalifornia, USA',
        phone: '(661) 677-4253',
        email: 'Alberto.406@hotmail.com',
        hours: 'Lunes - Viernes: 9am - 6pm\nSábados: 10am - 2pm',
        zelle: '(661) 677-4253'
      }
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      disclaimer: 'No somos abogados. Proveemos servicios de preparación de documentos y asistencia con formularios.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About Us',
      contact: 'Contact',
      portal: 'My Tax Portal',
      switchLang: 'Español'
    },
    hero: {
      title: 'Your Safe Path in Immigration and Finances',
      subtitle: 'Dedicated experts guiding you through your immigration processes and tax preparation with honesty and precision.',
      cta1: 'Free Consultation',
      cta2: 'Report Taxes Now',
      portalCta: 'My Tax Portal'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Comprehensive solutions for your legal and financial peace of mind in the United States.',
      immigration: {
        title: 'Immigration Services',
        desc: 'We accompany you every step of your immigration process with expert advice.',
        items: ['Family Petitions', 'Citizenship & Naturalization', 'Work Permits', 'Green Card Renewal', 'Asylum & DACA']
      },
      taxes: {
        title: 'Tax Preparation',
        desc: 'We maximize your refund and ensure compliance with the IRS.',
        items: ['Personal & Business Taxes', 'ITIN Application & Renewal', 'Prior Year Amendments', 'Financial Consulting', 'Basic Bookkeeping'],
        portalBtn: 'Go to Tax Portal',
        scanText: 'Scan to Report'
      }
    },
    about: {
      title: 'Why Choose Us',
      desc: 'With years of experience serving the community, we understand your needs and concerns. Our commitment is to provide you with transparent, fast, and effective service.',
      stats: [
        { label: 'Years of Experience', value: '10+' },
        { label: 'Successful Cases', value: '5k+' },
        { label: 'Satisfied Clients', value: '100%' }
      ]
    },
    contact: {
      title: 'Contact Us Today',
      subtitle: 'We are here to help you navigate your processes with confidence.',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        service: 'Service of Interest',
        message: 'Message',
        submit: 'Send Message'
      },
      info: {
        address: 'Serving the Kern County Community\nCalifornia, USA',
        phone: '(661) 677-4253',
        email: 'Alberto.406@hotmail.com',
        hours: 'Monday - Friday: 9am - 6pm\nSaturday: 10am - 2pm',
        zelle: '(661) 677-4253'
      }
    },
    footer: {
      rights: 'All rights reserved.',
      disclaimer: 'We are not attorneys. We provide document preparation services and form assistance.'
    }
  }
};